export const ERR = {
  "session-rejected": "Sharekhan rejected the session (expired or revoked). Sign in again through the login window.",
  "session-rejected-earlier": "Skipped because Sharekhan rejected the session on an earlier step.",
  "network-or-timeout": "Sharekhan or the gateway did not answer in time after bounded retries.",
  "rate-limited": "Sharekhan throttled the request (HTTP 429) after bounded retries.",
  "bad-response": "Sharekhan returned a response that was not valid JSON.",
  "missing-data-envelope": "Malformed broker data: the response had no data section.",
  "broker-error-status": "Sharekhan returned an error status instead of data.",
  "unexpected-shape": "Malformed broker data: the response had an unexpected structure.",
  "no-numeric-fields": "Malformed broker data: no numeric funds values were present.",
  "broker-auth-message": "Sharekhan answered with a session/authorization message instead of data. Sign in again.",
  "broker-error-message": "Sharekhan answered with an error message instead of data (or malformed JSON text).",
  "unrecognized-string": "Sharekhan returned text that is neither data nor a recognized 'no records' message; nothing was assumed.",
  "no-records-mismatch": "Sharekhan returned a 'no records' reply that does not match this endpoint or was not marked successful; nothing was assumed.",

  blocked: "Request blocked by the read-only guard.",
  error: "Unexpected error; nothing was saved for this item.",
};

export const FLAG = {
  stale_data: "Snapshot is older than 24 hours — run a new sync during an authorized session.",
  incomplete_snapshot: "Holdings snapshot is incomplete (some rows were rejected as malformed).",
  latest_sync_failed: "The most recent sync failed; results below come from an earlier snapshot.",
  latest_sync_partial: "The most recent sync was partial; results below come from an earlier snapshot.",
  latest_sync_abandoned: "The most recent sync was interrupted; results below come from an earlier snapshot.",
  no_holdings_snapshot: "No real holdings snapshot is available yet. Sign in to Sharekhan and run a sync.",
  snapshot_undecryptable: "The latest snapshot cannot be decrypted (key changed or record tampered). Run a new sync.",
};

export const REC_LABEL = {
  matched: "Matched", missing_in_tradify: "Missing in Tradify", missing_at_broker: "Missing at Sharekhan",
  quantity_mismatch: "Quantity mismatch", price_mismatch: "Price mismatch", unreadable: "Unreadable",
  duplicate_broker_record: "Duplicate (Sharekhan)", duplicate_tradify_record: "Duplicate (Tradify)",
  unexpected_position: "Unexpected position (unverified)",
};

export const TONE = {
  ok: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  completed: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  matched: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  unverified: "text-sky-300 border-sky-500/40 bg-sky-500/10",
  partial: "text-amber-300 border-amber-500/40 bg-amber-500/10",
  action_required: "text-amber-300 border-amber-500/40 bg-amber-500/10",
  failed: "text-rose-300 border-rose-500/40 bg-rose-500/10",
  abandoned: "text-rose-300 border-rose-500/40 bg-rose-500/10",
  skipped: "text-slate-400 border-slate-600/40 bg-slate-500/10",
};

export const tone = (s) => TONE[s] || "text-slate-400 border-slate-600/40 bg-slate-500/10";

export function ago(sec) {
  if (sec == null) return "—";
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
}

export const utc = (iso) => (iso ? `${String(iso).slice(0, 16).replace("T", " ")} UTC` : "—");
